module.exports = __webpack_public_path__ + "img/ring_r_skip_0_null.af05af00.png";